import { ActionTree } from 'vuex'

import { ShopState, RootState } from '@/types/store'
import { ShopType } from '@/types/shop'

import {
  getUncheckedShops,
  getCheckedShops,
  postShop,
  putShop,
} from '@/api/shops'
import { IShop } from '@/types/shop'

export const actions: ActionTree<ShopState, RootState> = {
  async getUncheckedShops({ commit }): Promise<void> {
    commit('shopsLoaded', [])
    commit('shopsLoadStart', true)
    const shops = await getUncheckedShops()
    commit('shopsLoaded', shops)
  },
  async getCheckedShops({ commit }): Promise<void> {
    commit('shopsLoaded', [])
    commit('shopsLoadStart', true)
    const shops = await getCheckedShops()
    commit('shopsLoaded', shops)
  },
  setShopType({ commit }, shopType: ShopType): void {
    commit('setShopType', shopType)
  },
  async postShop(_, shop: IShop): Promise<IShop> {
    return await postShop(shop)
  },
  async putShop(_, shop: IShop): Promise<IShop> {
    return await putShop(shop)
  },
}
